import React, { useState } from 'react';

import { getLabelFromName } from '../../helpers/formUtils';

import FilterInput from './FilterInput';

import { ColumnFilters, FilterChangeCallback, FilterComponentProps } from './types';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function Filter({ column, label, type }: FilterComponentProps) {
    return null;
}

export const selectBooleanOptions = { 1: 'Yes', 0: 'No' };

type Props = {
    columnFilters: ColumnFilters;
    onFilterChange: FilterChangeCallback;
    children: React.ReactNode;
};

function FilterByColumn({ columnFilters, onFilterChange, children }: Props) {
    const components: { [key: string]: FilterComponentProps } = {};
    const [selectedFilter, setSelectedFilter] = useState<FilterComponentProps>(null);

    React.Children.forEach(children, (element) => {
        if (React.isValidElement(element) && (element as React.ReactElement).type === Filter) {
            components[(element.props as FilterComponentProps).column] = element.props;
        }
    });

    const clearFilter = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, column: string) => {
        event.stopPropagation(); // avoid bootstrap dropdown close

        if (columnFilters[column]) {
            onFilterChange(column, undefined);
        }
    };

    return !Object.getOwnPropertyNames(components).length ? null : (
        <span className="mr-3">
            <div className="form-group d-inline-block">
                <div className="dropdown filter-by-column">
                    <button
                        className="btn btn-white border dropdown-toggle"
                        type="button"
                        id="filterByColumn"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                    >
                        {selectedFilter
                            ? selectedFilter?.label ?? getLabelFromName(selectedFilter.column)
                            : 'Filter by'}
                    </button>

                    <div className="dropdown-menu shadow" aria-labelledby="filterByColumn">
                        {Object.entries(components).map(([column, component], index) => (
                            <div key={`${index + 1}`} className="dropdown-item">
                                <button
                                    className="filter-item"
                                    type="button"
                                    onClick={() => setSelectedFilter(component)}
                                >
                                    {component.label ?? getLabelFromName(column)}
                                </button>

                                <button className="clear-filter" type="button" onClick={(e) => clearFilter(e, column)}>
                                    {columnFilters[column] ? '\u2716' : ' '}
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <FilterInput selected={selectedFilter} filters={columnFilters} onChange={onFilterChange} />
        </span>
    );
}

export default FilterByColumn;
